import { render, staticRenderFns } from "./replacecollector.vue?vue&type=template&id=1d977a60&"
import script from "./replacecollector.vue?vue&type=script&lang=ts&"
export * from "./replacecollector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "replacecollector.vue"
export default component.exports